import { routes } from '@sketch/constants'
import { ProjectFragment } from '@sketch/gql-types'
import { matchPath } from 'react-router-dom'

export const formatProjectName = (
  project: Pick<ProjectFragment, 'type' | 'name'>
) => {
  if (project.type === 'PERSONAL_DRAFTS') {
    return 'My Drafts'
  }

  return project.name
}

export const isViewingCurrentProject = (pathname: string) => {
  const match = matchPath(pathname, {
    path: routes.WORKSPACE_PROJECT.template(),
    exact: true,
    strict: false,
  })

  return Boolean(match)
}
